/**
 * Widget registry — metadata only, no default configs.
 * Default configs come from backend via WidgetPluginManager.
 *
 * i18n convention: `label` and `description` contain i18n keys
 * (e.g. 'dashboard.widgetTypeIndicator') resolved via `t()` against
 * JSON translation files (ru.json, en.json). This is NOT Drupal's
 * .po system — keys are dot-separated paths into nested JSON, not
 * English source strings. So `label` IS the key, no `Key` suffix needed.
 */

import type { WidgetType } from './dashboard';

export interface WidgetRegistryItem {
  type: WidgetType;
  label: string;
  icon: string;
  description: string;
}

export const WIDGET_REGISTRY: WidgetRegistryItem[] = [
  {
    type: 'indicator',
    label: 'dashboard.widgetTypeIndicator',
    icon: 'las la-chart-bar',
    description: 'dashboard.widgetTypeIndicatorDescription',
  },
  {
    type: 'labeled_list',
    label: 'dashboard.widgetTypeLabeledList',
    icon: 'las la-list',
    description: 'dashboard.widgetTypeLabeledListDescription',
  },
  {
    type: 'chart',
    label: 'dashboard.widgetTypeChart',
    icon: 'las la-chart-pie',
    description: 'dashboard.widgetTypeChartDescription',
  },
  {
    type: 'chat',
    label: 'dashboard.widgetTypeChat',
    icon: 'las la-comments',
    description: 'dashboard.widgetTypeChatDescription',
  },
  {
    type: 'entity_list',
    label: 'dashboard.widgetTypeEntityList',
    icon: 'las la-th-list',
    description: 'dashboard.widgetTypeEntityListDescription',
  },
];
